<template>
  <a-form class="loginForm" :form="form" @submit="handleSubmit">
    <a-form-item :validate-status="usernameError() ? 'error' : ''" :help="usernameError() || ''">
      <a-input
        v-decorator="[
					'username',
					{rules: [
						{ required: true, message: '请输入用户名称!' },
						{ max: 20, message: '长度不可超过20个字符！' }
					]}
				]"
        placeholder="请输入用户名称"
      >
        <a-icon slot="prefix" type="user" />
      </a-input>
    </a-form-item>
    <a-form-item :validate-status="passwordError() ? 'error' : ''" :help="passwordError() || ''">
      <a-input
        v-decorator="[
					'password',
					{rules: [
						{ required: true, message: '请输入登录密码!' },
						{ max: 20, message: '长度不可超过20个字符！' }
					]}
				]"
        type="password"
        placeholder="请输入登录密码"
      >
        <a-icon slot="prefix" type="lock" />
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-button
        html-type="submit"
        type="primary"
        :disabled="hasErrors(form.getFieldsError())"
        @keyup.enter="submit"
      >登录</a-button>
    </a-form-item>
    <a-form-item>
      <span class="sysVersion">版本·V1.0</span>
    </a-form-item>
  </a-form>
</template>

<script>
import { LOGIN } from "@/../static/js/API/apis.js";
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}
export default {
  name: "LoginForm",
  data() {
    return {
      hasErrors,
      form: this.$form.createForm(this)
    };
  },
  methods: {
    // Only show error after a field is touched.
    usernameError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("username") && getFieldError("username");
    },
    // Only show error after a field is touched.
    passwordError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("password") && getFieldError("password");
    },
    handleSubmit(e) {
      const self = this;
      e.preventDefault();
      self.form.validateFields((err, values) => {
        if (!err) {
          var formData = new FormData();
          formData.append("username", values.username);
          formData.append("password", values.password);
		  LOGIN(formData).then(res => {
			//console.log(res);
			if (res.code == "200") {
              	localStorage.setItem("username", values.username);
              self.$router.push({ path: "/Home" });
            } else {
              self.$message.error("用户名或密码错误!");
            }
		  });
        } else {
          self.$message.error("请正确填写用户名密码！");
        }
      });
    }
  }
};
</script>

<style scoped>
.ant-form-item {
  margin-bottom: 18px;
}
/*添加deep后可覆盖样式，否则不生效，跟icon的slot有关*/

/deep/ .ant-input:focus {
  box-shadow: 0px 0px 1px #eaaa1a inset;
}
/deep/ .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
  box-shadow: 0px 0px 1px #eaaa1a inset;
}
/deep/ .ant-input:not(:first-child) {
  padding-left: 50px;
}
.ant-form-item .ant-input-prefix i {
  font-size: 18px;
}
/*button style*/
.ant-btn {
  width: 100%;
  font-weight: 700;
}
.sysVersion {
  width: 100%;
  text-align: center;
  display: block;
  color: #ccc;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Login/components/loginForm.vue